import React from "react"

import SelectMultiGenericOptionPill from "./option-pill"

type Props = {
    className?  : string

    options     : Option[]

    onClick     : func
    onDelete    : func

    children    : any
}

// const debug = "SelectMultiGenericValueNotEmpty"
const debug = false

export default function SelectMultiGenericValueNotEmpty(props: Props) {

    debug && console.log(debug, "render", props)

    return (
        <>
            <div className={Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => {
                    return <SelectMultiGenericOptionPill key        = {option.value}
                                                         className  = "m-r-10 m-t-4 m-b-4"
                                                         option     = {option}
                                                         onDelete   = {props.onDelete}/>
                })}
            </div>
            {props.children}
        </>
    )
}